<div class="visitortype-related-image" >
    <sc-padding>
        <sc-flex vertical fitHeight stretchContent>
            <img src="{{imageUrl}}"/>
        </sc-flex>
    </sc-padding>
</div>
